import { render } from "./AddNewUsersForm.vue?vue&type=template&id=298b29aa"
import script from "./AddNewUsersForm.vue?vue&type=script&lang=js"
export * from "./AddNewUsersForm.vue?vue&type=script&lang=js"

import "./AddNewUsersForm.vue?vue&type=style&index=0&id=298b29aa&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__